<template>
    <div :class="{'dark':darkMode.enabled}">
        <div @click="$refs.nav.showMenu = false" class="relative from-white to-slate-50 bg-gradient-to-tr dark:from-black dark:to-gray-900 dark:selection:bg-gray-400 dark:text-gray-400 w-full max-w-screen min-h-screen" :class="{'pb-[17rem] md:pb-14': !navHidden}">

            <Nav :hidden="navHidden" ref="nav"/>

            <RouterView v-slot="{ Component, route }" @navHidden="navHidden = $event">
                <template v-if="Component">
                    <!-- <KeepAlive v-if="route.path.includes('resources')">
                        <Suspense :timeout="200">
                            <Component :is="Component" :key="route.meta.usePathKey ? route.path : undefined" />
                            <template #fallback><spinner /></template>
                        </Suspense>
                    </KeepAlive> -->
                    <Suspense :timeout="200" >
                        <Component :is="Component" :key="route.meta.usePathKey ? route.path : undefined" />
                        <template #fallback><spinner /></template>
                    </Suspense>
                </template>
                <Spinner v-else />
            </RouterView>

            <MiniPlayer v-if="store.nowPlaying?.id" class="fixed bottom-0 left-0 z-[51]" />

            <Footer class="absolute bottom-0" v-show="!navHidden" />

            <Modal v-if="allowedVideos.includes(promoVideo)" @hide="$router.push({query: {}})" maxWidth="max-w-4xl !p-0">
                <iframe
                    :src="`https://player.vimeo.com/video/${promoVideo}?h=68e999d930&color=6585a3&byline=0&portrait=0&title=0&autoplay=1`"
                    class="w-full aspect-video"
                />
            </Modal>

        </div>
    </div>
</template>

<script>
import Nav from './components/_sbo/nav.vue'
import MiniPlayer from './components/layout/mini-player.vue'
import Footer from './components/_sbo/footer.vue'
import Modal from './components/layout/modal.vue'

// Function for setting cookies
let setCookie = function (cname, cvalue) {
    var d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export default {
    components: {Nav, MiniPlayer, Footer, Modal},
    inject: ['store','darkMode','axios'],
    data() {
        return {
            navHidden: false,
            allowedVideos: [
                '863273014',
                '812567580',
                '809150337',
                '810305788',
                '522413191',
                '709198735',
                '844611074',
                '853107156',
                '841278292',
                '867965434',
                '863329214',
                '863278705',
                '863329058',
                '863271654',
                '863329102',
                '863272250',
                '863329138',
                '863272722',
                '863329182',
                '870301889',
                '870339299',
            ],
        }
    },
    watch: {
        loggedIn: {
            handler() {
                const token = new URLSearchParams(window.location.search).get("token");
                // Save credentials for people who are already logged in through a qs or something
                if (this.loggedIn && token) {
                    setCookie(`Authorization`, token)
                    this.axios.defaults.headers.common['Authorization'] = token

                    // console.log('this.store.user', this.store.user)

                    window.localStorage.setItem('user', this.store.user?.member?.id)
                    window.localStorage.setItem('email', this.store.user?.member?.email)

                    // this.$router.push({path: this.$route.path, query: {}})
                    window.history.replaceState({}, document.title, window.location.pathname);
                    setTimeout(() => {window.history.replaceState({}, document.title, window.location.pathname);}, 500);
                    setTimeout(() => {window.history.replaceState({}, document.title, window.location.pathname);}, 1000);
                    setTimeout(() => {window.history.replaceState({}, document.title, window.location.pathname);}, 1500);
                    setTimeout(() => {window.history.replaceState({}, document.title, window.location.pathname);}, 2000);

                }
            },
            immediate: true
        },
        navHiddenFromRoute: {
            handler() {
                this.navHidden = this.navHiddenFromRoute
            },
            immediate: true
        },
        navHidden: {
            handler() {
                if (this.navHidden) Tawk_API?.hideWidget?.();
                setTimeout(() => {
                    if (this.navHidden) Tawk_API?.hideWidget?.();
                }, 1000);
                setTimeout(() => {
                    if (this.navHidden) Tawk_API?.hideWidget?.();
                }, 2000);
            },
            immediate: true
        }
    },
    mounted() {
        document.title = 'Scott Brown Online'
    },
    computed: {
        loggedIn() { return !!this.store.user?.member?.id },
        token() { return this.$route.query?.token },
        promoVideo() { return this.$route.query?.video },
        navHiddenFromRoute() { return !!this.$route.query?.navHidden },
    }
}
</script>

<style lang="postcss">
@import url('https://fonts.googleapis.com/css2?family=Inconsolata&display=swap');
/* Reset default styles for the select element */
/* Reset default styles for the select element */
select {
  appearance: none; /* Remove default appearance on some browsers */
  -webkit-appearance: none; /* Remove default appearance on Safari */
  -moz-appearance: none; /* Remove default appearance on Firefox */
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0px center; /* Adjust the position of the arrow */
}

/* Apply the filter utility to change SVG color in dark mode */
.dark select {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='rgba(255, 255, 255, 0.5)' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E");
}
</style>
